import {
  buildWorksheetSlots,
  type WorksheetSlot,
  type WorksheetSlotDeps,
} from '../utils/buildWorksheetSlots';

export function useWorksheetSlots(deps: WorksheetSlotDeps): WorksheetSlot[] {
  return buildWorksheetSlots(deps)
    .filter((slot) => !!slot.render)
    .sort((a, b) => a.index - b.index);
}
